import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.css'
import axios from 'axios'
import * as echarts from 'echarts'
import store from './store'
import serverConfig from "./http/config/index.js"
import ver from './verification/index.js'
// 全局组件
import '@/components'
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$ver = ver;
//带水印图片上传
// Vue.prototype.$uploadUrl = serverConfig.baseURL + '/api/base/upload';
Vue.prototype.$uploadUrl = serverConfig.baseURL + '/api/file/upload';
//文件上传
Vue.prototype.$uploadFileUrl = serverConfig.baseURL + '/api/base/uoload';
//文件上传
Vue.prototype.$uploadFileUrl1 = serverConfig.baseURL + '/api/file/upload';
//图片显示前缀
Vue.prototype.$imgUrl = serverConfig.baseURL;


/* by su start */
//允许图片类型
//image/*,.pdf  == 图片和pdf
Vue.prototype.$imgExt = 'image/*';
//允许文件类型
Vue.prototype.$fileExt = '';

/**
 * this.formatTime()
 */
const formatTime = date => {
	if (!date) {
		date = new Date()
	}
	//快速获取年月日时分秒
	// new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," ")
	console.log(date, date.getFullYear());
	// return
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	let day = date.getDate();
	let hour = date.getHours();
	let minute = date.getMinutes();
	let second = date.getSeconds();

	month = month < 10 ? '0' + month : month;
	day = day < 10 ? '0' + day : day;
	hour = hour < 10 ? '0' + hour : hour;
	minute = minute < 10 ? '0' + minute : minute;
	second = second < 10 ? '0' + second : second;
	return `${[year, month, day].join('-')} ${[hour, minute, second].join(':')}`;
};
Vue.prototype.formatTime = formatTime;

/* by su end */

Vue.config.productionTip = false;
Vue.use(ElementUI);

//跳转页面以后，回到顶部
router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
});
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
